import {Type} from '@mintdata/mint-kit/api/types/Type';
import {IValue} from '@mintdata/mint-kit/api/types/Value';
import {BaseValue} from '@mintdata/mint-kit/api/values/BaseValue';
import {migrated, primitive, serializable} from '@mintdata/mint-kit/impl/util/serializr/src/serializr';

export class AError extends BaseValue
{
    @serializable public readonly __isError:boolean = true;
    @serializable(migrated('error', primitive()))
    public readonly __errorMessage:string;
    @serializable(migrated('errorContext', primitive()))
    public readonly __errorContext:string;

    constructor(error:string,
                errorContext:string = null)
    {
        super(Type.Error);
        this.__errorMessage = error;
        this.__errorContext = errorContext;
    }

    public get error():string
    {
        return this.__errorMessage;
    }

    public get errorContext():string
    {
        return this.__errorContext;
    }

    public toString():string
    {
        return this.error;
    }

    public toValue():string
    {
        let errorContextStr = this.__errorContext ? `"${this.__errorContext}"` : `null`;
        return `{"__isError":true, "__errorMessage":"${this.__errorMessage}", "__errorContext": ${errorContextStr}}`;
    }

    public isEqualTo(other:IValue):boolean
    {
        if( other && Type.isInstanceOf(other, Type.Error) )
        {
            const otherError = other as AError;

            return otherError
                && this.__isError === otherError.__isError
                && this.__errorMessage === otherError.__errorMessage
                && this.__errorContext === otherError.__errorContext;
        }

        return false;
    }

    public compareTo(other:IValue):number
    {
        if( this.isEqualTo(other) )
            return 0;

        return -1;
    }

    public clone():IValue
    {
        return new AError(this.error);
    }

    public static fromString(value:string):AError
    {
        return new AError(value);
    }

    public static isSerializedErrorValue(obj:any):boolean
    {
        return obj && obj.__isError && obj.__isError === true;
    }

    public static deserializeError(obj:any):AError
    {
        if( AError.isSerializedErrorValue(obj) )
            return new AError(obj.__errorMessage);
        else
            throw new Error(`Invalid error object: ${obj}`);
    }
}
